import { State } from '../state';
import { ActionType, ApplicationAction } from './types';

export type Patch = (update: Partial<State>) => void;
export const patch = (payload: Partial<State>, type: ActionType = ActionType.Patch): ApplicationAction => ({
  type, payload
});
